export const SET_ACTIVE_ROOM = "SET_ACTIVE_ROOM";
export const SET_PARTICIPANTS = "SET_PARTICIPANTS";
